// Wishlist Functionality
class Wishlist {
  constructor() {
    this.storageKey = 'pind_wishlist';
    this.wishlist = this.getWishlist();
    this.init();
  }

  init() {
    // Handle heart button clicks
    document.addEventListener('click', (e) => {
      const button = e.target.closest('.wishlist-heart');
      if (button) {
        e.preventDefault();
        const productHandle = button.dataset.handle;
        const productTitle = button.dataset.title;
        const productImage = button.dataset.image;
        const productUrl = button.dataset.url;
        const productPrice = button.dataset.price;
        
        this.toggle({
          handle: productHandle,
          title: productTitle,
          image: productImage,
          url: productUrl,
          price: productPrice
        }, button);
      }
    });

    // Update hearts on page load
    this.updateAllHearts();
  }

  getWishlist() {
    try {
      const saved = localStorage.getItem(this.storageKey);
      return saved ? JSON.parse(saved) : [];
    } catch (e) {
      return [];
    }
  }

  saveWishlist() {
    localStorage.setItem(this.storageKey, JSON.stringify(this.wishlist));
  }

  toggle(product, button) {
    const index = this.wishlist.findIndex(item => item.handle === product.handle);
    
    if (index > -1) {
      // Remove from wishlist
      this.wishlist.splice(index, 1);
      button.classList.remove('active');
    } else {
      // Add to wishlist
      this.wishlist.push(product);
      button.classList.add('active');
    }
    
    this.saveWishlist();
    
    // Update wishlist page if we're on it
    if (window.location.pathname.includes('wishlist')) {
      this.renderWishlistPage();
    }
  }

  updateAllHearts() {
    document.querySelectorAll('.wishlist-heart').forEach(button => {
      const handle = button.dataset.handle;
      if (this.wishlist.find(item => item.handle === handle)) {
        button.classList.add('active');
      }
    });
  }

  renderWishlistPage() {
    const container = document.getElementById('wishlist-items');
    if (!container) return;

    if (this.wishlist.length === 0) {
      container.innerHTML = '<p class="text-center">Your wishlist is empty</p>';
      return;
    }

    const html = this.wishlist.map(product => `
      <div class="wishlist-item">
        <a href="${product.url}" class="wishlist-item__image">
          <img src="${product.image}" alt="${product.title}">
        </a>
        <div class="wishlist-item__info">
          <a href="${product.url}" class="wishlist-item__title">${product.title}</a>
          <p class="wishlist-item__price">${product.price}</p>
          <button class="wishlist-heart active remove-wishlist"
                  data-handle="${product.handle}"
                  data-title="${product.title}"
                  data-image="${product.image}"
                  data-url="${product.url}"
                  data-price="${product.price}">
            Remove from wishlist
          </button>
        </div>
      </div>
    `).join('');

    container.innerHTML = html;
  }
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.wishlist = new Wishlist();
    // If on wishlist page, render items
    if (window.location.pathname.includes('wishlist')) {
      window.wishlist.renderWishlistPage();
    }
  });
} else {
  window.wishlist = new Wishlist();
  if (window.location.pathname.includes('wishlist')) {
    window.wishlist.renderWishlistPage();
  }
}